
import { post, get, setNewPass, sendDelete } from '../helpers/api.helper';

export async function login(payloadValue) {
    try {
        return await post('usuarios/login', payloadValue);
    } catch (error) {
        console.error('Erro ao criar cadastro');
    }
}

export async function create(payloadValue) {
    try {
        return await post('usuario', payloadValue);
    } catch (error) {
        console.error('Erro ao criar cadastro');
    }
}

export async function List() {
    try {
        return await get('usuario');
    } catch (error) {
        console.error('Erro ao criar cadastro');
    }
}

export async function getSupervisor() {
    try {
        return await get('supervisor');
    } catch (error) {
        console.error('Erro ao buscar informações');
    }
}

export async function PaginatedList(pageSize, page) {
    try {
        return await get(`usuario/paginated?page=${page}&pageSize=${pageSize}`);
    } catch (error) {
        console.error('Erro ao criar cadastro');
    }
}

export async function GetUser(id) {
    try {
        return await get(`usuario/${id}`);
    } catch (error) {
        console.error('Erro ao buscar cadastro');
    }
}

export async function UpdateTypeUser(user) {
    try {
        return await post(`/user/type`, user);
    } catch (error) {
        console.error('Erro ao buscar cadastro');
    }
}

export async function ChangePassword(user) {
    try {
        return await post(`/usuario/${user.id}/password/reset`, user);
    } catch (error) {
        console.error('Erro ao buscar cadastro');
    }
}

export async function setCustomerUser(id_customer, id_user) {
    try {
        let payload = { cliente: parseInt(id_customer), user: parseInt(id_user) };
        return await post(`user/responsavel/`, payload);
    } catch (error) {
        console.error('Erro ao buscar cadastro');
    }
}

export async function ActivateUser(id) {
    try {
        let payload = { id: id }
        return await post('usuario/activate', payload);
    } catch (error) {
        console.error('Erro ao criar cadastro');
    }
}

export async function resetPass(id) {
    try {
        return await get(`usuario/recoverpass?cpf=${id}`);
    } catch (error) {
        console.error('Erro ao criar cadastro');
    }
}

export async function setResetPass(token) {
    try {
        return await setNewPass(`usuario/setrecoverpass`, token);
    } catch (error) {
        console.error('Erro ao criar cadastro');
    }
}

export async function deleteItem(id) {
    try {
        return await sendDelete(`usuario/${id}`);
    } catch (error) {
        console.error('Erro ao processar requisição');
    }
}